module.exports = __webpack_public_path__ + "static/media/imagepng.a75f47c6.svg";